import '/assets/styles/layouts/guide.scss';
import classNames from 'classnames';

// Sections
import Header from '/views/sections/header';
import Footer from '/views/sections/footer';

// Partials
import Btn from '/views/partials/btn';

// Context
import { useNavigator } from '@wearetla/tla-essentials-tools/utilities/navigator';
import { useMemo } from 'react';

const SidemenuLayout = ({ children, pageClass, className, title }) => {
	const { activeRoute, routes } = useNavigator();

	const menuItems = useMemo(() => {
		const mainRouteKey = activeRoute.key.split('.')[0];
		const childRoutes = routes[mainRouteKey]?.children ?? {};

		return Object.keys(childRoutes).map((routeKey) => {
			const route = childRoutes[routeKey];

			return {
				key: `${mainRouteKey}.${routeKey}`,
				route,
				href: `${mainRouteKey}.${routeKey}`,
				title: route.layoutProps?.title ?? route.head?.title ?? routeKey,
				icon: route.menuIcon,
			};
		});
	}, [activeRoute, routes]);

	return (
		<div
			className={classNames(
				'page',
				'layout-guide',
				className,
				pageClass ? `page-${pageClass}` : null
			)}
		>
			<Header />
			<div>
				<div className="layout-guide-heading">
					{!!menuItems?.length && (
						<nav className="layout-guide-nav">
							<ul className="nav-list wrapper">
								{menuItems.map((item) => (
									<li className="nav-list-item" key={item.key}>
										<Btn
											icon={item.icon}
											className={classNames('item-btn block', {
												primary: item.key === activeRoute.key,
											})}
											tag="link"
											href={item.href}
										>
											{item.title}
										</Btn>
									</li>
								))}
							</ul>
						</nav>
					)}
				</div>

				<div className="layout-guide-content">
					{title && (
						<header className="layout-guide-content-header">
							<div className="wrapper">
								<h1 className="layout-guide-content-title">{title}</h1>
							</div>
						</header>
					)}
					{children}
				</div>
			</div>
			<Footer />
		</div>
	);
};

export default SidemenuLayout;
